/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthAuthorizeResVo
 */
export interface OAuthAuthorizeResVo {
    /**
     * Kakao 官方授权地址
     * Kakao官方授权地址
     * @type {string}
     * @memberof OAuthAuthorizeResVo
     */
    authorizeUrl?: string;
}

/**
 * Check if a given object implements the OAuthAuthorizeResVo interface.
 */
export function instanceOfOAuthAuthorizeResVo(value: object): value is OAuthAuthorizeResVo {
    return true;
}

export function OAuthAuthorizeResVoFromJSON(json: any): OAuthAuthorizeResVo {
    return OAuthAuthorizeResVoFromJSONTyped(json, false);
}

export function OAuthAuthorizeResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthAuthorizeResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'authorizeUrl': json['authorizeUrl'] == null ? undefined : json['authorizeUrl'],
    };
}

export function OAuthAuthorizeResVoToJSON(json: any): OAuthAuthorizeResVo {
    return OAuthAuthorizeResVoToJSONTyped(json, false);
}

export function OAuthAuthorizeResVoToJSONTyped(value?: OAuthAuthorizeResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authorizeUrl': value['authorizeUrl'],
    };
}

